export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    baseProfile="tiny"
    x="0px"
    y="0px"
    viewBox="143 -100.4 439.9 419.6"
    xmlSpace="preserve"
  >
    <path
      fill="#FFFFFF"
      d="M351.9 244.8l-101.4 70.6c-15.1 10.5-34.9-3.9-29.6-21.5l35.8-118.2c2.3-7.8-0.4-16.2-6.8-21.1L151.4 80 c-14.6-11.1-7.1-34.4 11.3-34.8l123.5-2.5c8.1-0.2 15.2-5.4 17.9-13l40.6-116.7c6-17.4 30.6-17.4 36.6 0l40.6 116.7 c2.7 7.7 9.8 12.8 17.9 13l123.5 2.5c18.4 0.4 25.9 23.7 11.3 34.8l-98.4 74.6c-6.5 4.9-9.2 13.3-6.8 21.1l35.8 118.2 c5.3 17.6-14.5 32-29.6 21.5l-101.4-70.6C367.4 240.2 358.6 240.2 351.9 244.8z"
    />
  </svg>
);
